import ButtonSimple from './buttons/ButtonSimple';
import { getGA } from 'analytics/GoogleAnalytics';
import { processCaptions } from 'utils/utils';

export default class CutscenePlayer extends Phaser.Group {
  constructor(game, id) {
    super(game);
    this.cutsceneId = id;
    this.data = this.game.controller.getCutsceneData(id).data;
    console.log(this.cutsceneId);

    // save
    this.game.controller.player.saveCutscene(this.cutsceneId);

    //
    if (!this.data.onlyAnim) {
      this.setAudioId(id);
    }
    this.onAnimComplete = new Phaser.Signal();

    this.audioSkeleton = null;

    //
    // build scene
    this.makeScene();

    // play first anim
    this.playAnim(this.data.anims[0]);
  }

  setAudioId(id) {
    this.audioId = id + '_vo';
    this.cptData = this.game.cache.getJSON(id + '_captions');
    this.cptData = processCaptions(this.game, this.cptData, this.audioId + '-audioatlas');
    this.game.springRollCaptionsPlugin.setData(this.cptData);
  }

  // processCaptions(audioName) {
  //   const vosData = this.game.cache.getJSON(audioName);

  //   for (const key in vosData.spritemap) {
  //     if (vosData.spritemap.hasOwnProperty(key)) {
  //       const cptItem = this.cptData[key];
  //       if (!cptItem) {
  //         console.log("can't find: " + key);
  //       } else {
  //         const cpt = cptItem[0];
  //         const vo = vosData.spritemap[key];
  //         cpt.start = 0;
  //         if (vo) {
  //           cpt.end = (vo.end - vo.start) * 1000 + 100;
  //         } else {
  //           cpt.end = 1000; // 0;
  //         }
  //       }
  //     }
  //   }
  // }

  getIcon() {
    const ind = this.data.skeletons.indexOf(this.data.icon_skeleton_id);
    const skel = this.skeletons[ind];
    this.skeletons[ind] = null; // remove reference
    return skel;
  }

  showSkipButton() {
    // skip button
    this.btnSkip = new ButtonSimple({ game: this.game, up: 'btn_skip', over: 'btn_skip' });
    this.btnSkip.x = this.game.width / 2 - 55;
    this.btnSkip.y = this.game.defaultHeight / 2 - 55;
    this.addChild(this.btnSkip);
    this.btnSkip.onInputDown.add(this.handleSkipButton, this);
  }

  handleSkipButton() {
    // tracking
    let season = this.game.controller.location;
    season = season.replace(/^\w/, (chr) => chr.toUpperCase());
    const label = season + ' Level ' + (this.game.controller.levelId + 1);
    getGA().track({ action: 'CutSceneSkip', label: label });

    //
    this.handleAnimComplete();
  }

  makeScene() {
    this.skeletons = [];
    for (let i = 0; i < this.data.skeletons.length; i++) {
      const name = this.data.skeletons[i];
      const skel = this.game.make.spine(0, 0, name, true);
      skel.anchor.set(0.5, 1);
      this.skeletons.push(skel);
      this.addChild(skel);

      //
      if (name === this.data.audio_skeleton_id) {
        this.audioSkeleton = skel;
        this.audioSkeleton.onEvent.add(this.handleAudioEvent, this);
      }
    }
  }

  handleAudioEvent(track, event) {
    track;
    this.textId = event.data.name;

    this.game.springRollCaptionsPlugin.playCaption(this.textId);
    this.game.sounds.playVO(this.textId, { spriteID: this.audioId });
  }

  playAnim(anim, loop = false) {
    if (this.game.controller.shortcutsModel.cutscenesEnabled) {
      let ind = -1;
      let time = 0;

      this.tracks = [];
      for (let i = 0; i < this.skeletons.length; i++) {
        const track = this.skeletons[i].setAnimationByName(0, anim, loop);
        if (track.animationEnd > 0 && track.animationEnd > time) {
          time = track.animationEnd;
          ind = i;
        }
        //
        this.tracks.push(track);
        track.timeScale = 0.01;
      }

      // add listener on longest anim complete
      if (ind >= 0) {
        this.skeletenWithEvent = this.skeletons[ind];
        this.skeletenWithEvent.onComplete.addOnce(this.handleAnimComplete, this);
        // console.log(time, this.skeletons[ind]);
        // this.timeEvent = this.game.time.events.add(
        //   time * 1000 + 500,
        //   this.handleAnimComplete,
        //   this
        // );
      }

      this.game.time.events.add(500, this.startAnim, this);
    } else {
      this.onAnimComplete.dispatch();
    }
  }

  startAnim() {
    for (let i = 0; i < this.tracks.length; i++) {
      this.tracks[i].timeScale = 1;
    }
    this.tracks = [];
  }

  handleAnimComplete() {
    // this.game.time.events.remove(this.timeEvent);
    // this.timeEvent = null;

    this.skeletenWithEvent.onComplete.remove(this.handleAnimComplete, this);
    this.skeletenWithEvent = null;

    // this.game.time.events.add(1, this.dispatchAnimComplete, this);
    this.dispatchAnimComplete();
  }

  dispatchAnimComplete() {
    console.log('anim complete');
    this.onAnimComplete.dispatch();
  }

  destroy() {
    if (this.btnSkip) {
      this.btnSkip.destroy();
      this.btnSkip = null;
    }

    // stop VO and captions
    this.game.springRollCaptionsPlugin.stopCaption();
    this.game.sounds.stopAudioSprite(this.textId, { spriteID: this.audioId });

    //
    for (let i = 0; i < this.skeletons.length; i++) {
      this.removeChild(this.skeletons[i]);
      if (this.skeletons[i]) {
        this.skeletons[i].destroy();
      }
    }
    this.skeletons = null;

    super.destroy();
  }
}
